import React from 'react';

import getFormattedDate from '../../../../../helpers/getFormattedDate';
import { withSkeleton } from '../../../../AppTable/helpers/withSkeleton';
import { withRowActions } from '../../../../AppTable/helpers/withRowActions';
import DataCell from '../../../../AppTable/cells/DataCell/DataCell';

const LastModified = ({ rowData }: $TSFixMe) => {
    return <DataCell data={getFormattedDate(rowData.updatedAt)} id={rowData.id} testKey="updatedAt" disableConditionalEllipsis isDate />;
};

export default withSkeleton({ height: 12, width: 100 })(withRowActions(LastModified));
